<template>
  <v-container fluid>
    <v-card>
      <v-toolbar color="secondary" dense flat>
        <v-toolbar-title>Item Stock Audit</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text color="accent" to="/check-stock">
          <v-icon left dark>mdi-keyboard-backspace</v-icon>Back
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <div>
          <v-row class="subtitle-2 text--primary">
            <v-col cols="12">
              <span v-if="product">{{ product.Name }}</span>
            </v-col>
            <v-col cols="12" xs="12" md="3">
              <v-menu
                v-model="menu1"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    dense
                    outlined
                    single-line
                    v-model="record.StartDate"
                    label="From"
                    prepend-icon="mdi-calendar-month"
                    v-on="on"
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker v-model="record.StartDate" @input="menu1 = false"></v-date-picker>
              </v-menu>
            </v-col>

            <!-- datepicker 2 -->
            <v-col cols="12" xs="12" md="3">
              <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    dense
                    outlined
                    single-line
                    v-model="record.EndDate"
                    label="To"
                    prepend-icon="mdi-calendar-month"
                    v-on="on"
                    readonly
                  ></v-text-field>
                </template>
                <v-date-picker v-model="record.EndDate" @input="menu2 = false"></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="12" xs="12" md="3">
              <v-autocomplete
                name="auditCheckStockStore"
                dense
                outlined
                v-model="queryStore"
                :items="stores"
                label="Select Shop"
                item-text="Name"
                item-value="id"
              ></v-autocomplete>
            </v-col>

            <v-col cols="3">
              <v-btn color="primary" :loading="loader" @click="getReport">Audit Stock</v-btn>
            </v-col>
          </v-row>

          <v-row class="subtitle-2 text--primary">
            <v-col cols="12" xs="12" md="10" class="mb-2">
              <div>
                Stock on Hand as Of {{ record.StartDate }}:
                <span style="color: red">{{ OpeningQty}}</span>
              </div>
            </v-col>

            <v-col cols="12" xs="12" md="10">
              <v-data-table
                light
                :mobile-breakpoint="0"
                :items-per-page="1000"
                :headers="auditHeaders"
                :items="auditData"
              >
                <!-- in qty template -->
                <template v-slot:item.InQty="{ item }">
                  <span v-if="item.InQty == 0">-</span>
                  <span v-else>{{ item.InQty }}</span>
                </template>
                <!-- end -->

                <!-- in qty template -->
                <template v-slot:item.OutQty="{ item }">
                  <span v-if="item.OutQty == 0">-</span>
                  <span v-else>{{ item.OutQty }}</span>
                </template>
                <!-- end -->

                   <!-- in qty template -->
                   <template v-slot:item.DocDate="{ item }">
                  {{ item.DocDate | date }}
                </template>
                <!-- end -->
              </v-data-table>
            </v-col>

            <v-col cols="12" xs="12" md="9" class="mb-2">
              <div>
                Stock on Hand as Of {{ record.EndDate }}:
                <span style="color: red">{{ ClosingQty }}</span>
              </div>
            </v-col>
          </v-row>

          <!-- purchase sale dialog -->
          <v-dialog
            v-model="salePurchaseDialog"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
          >
            <v-card>
              <v-toolbar dark color="accent" dense>
                <v-toolbar-title>
                  <v-btn icon dark @click.native="salePurchaseDialog = false">
                    <v-icon dark>mdi-keyboard-backspace</v-icon>
                  </v-btn>
                  {{ docName }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click.native="salePurchaseDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>

              <v-card-text>
                <v-container>
                  <v-row dense id="po" class="text--primary subtitle-2">
                    <v-col cols="12" xs="12" md="4" sm="4">
                      <span>
                        Customer:
                        {{ transRecord.ocrd && transRecord.ocrd.Name }}
                      </span>
                    </v-col>

                    <v-col cols="12" xs="12" md="4" sm="4">Receipt No: {{ transRecord.DocNum }}</v-col>

                    <v-col cols="12" xs="12" md="4" sm="4">Date: {{ transRecord.DocDate }}</v-col>

                    <v-col cols="12" id="docForm">
                      <!-- <v-alert
                        v-if="transRecord.rows.length == 0 && docCreate == true"
                        type="warning"
                        >You have not added any Item.</v-alert
                      >-->
                      <v-text-field v-model="search" label="search" dense outlined></v-text-field>
                      <v-data-table
                        light
                        :search="search"
                        :mobile-breakpoint="0"
                        :items-per-page="1000"
                        :headers="transHeaders"
                        :items="transRecord.rows"
                        item-key="id"
                        hide-default-footer
                      >
                        <!-- <template v-slot:item.ref1="{ item }">{{item.ref1}}</template> -->

                        <template v-slot:item.Quantity="{ item }">
                          {{
                          item.Quantity
                          }}
                        </template>

                        <template v-slot:item.Price="{ item }">
                          <span v-if="item.Price">
                            {{
                            item.Price.toLocaleString()
                            }}
                          </span>
                        </template>

                        <template v-slot:item.DiscSum="{ item }">
                          {{
                          item.DiscSum
                          }}
                        </template>

                        <template v-slot:item.DisplayTotal="{ item }">
                          {{
                          item.DisplayTotal
                          }}
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-divider></v-divider>
                  </v-row>

                  <v-row>
                    <v-col cols="6">
                      <v-row dense class="text--primary subtitle-2">
                        <v-col cols="6">
                          <span v-if="transRecord.DocTotal">
                            Total:
                            {{
                            transRecord &&
                            transRecord.DocTotal.toLocaleString()
                            }}
                          </span>
                        </v-col>

                        <v-col cols="6">
                          <span v-if="transRecord.PaidSum">
                            Paid:
                            {{
                            transRecord &&
                            transRecord.PaidSum.toLocaleString()
                            }}
                          </span>
                        </v-col>

                        <v-col cols="6">
                          <span v-if="transRecord.Balance">
                            Balance:
                            {{
                            transRecord &&
                            transRecord.Balance.toLocaleString()
                            }}
                          </span>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- end of dialog -->

          <!-- transfer dialog -->
          <v-dialog
            v-model="transferDialog"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
          >
            <v-card>
              <v-toolbar dark color="accent" dense>
                <v-toolbar-title>
                  <v-btn icon dark @click.native="transferDialog = false">
                    <v-icon dark>mdi-keyboard-backspace</v-icon>
                  </v-btn>Stock Transfer Details
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click.native="transferDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>

              <v-card-text>
                <v-container>
                  <v-row dense id="po" class="text--primary subtitle-2">
                    <v-col cols="12" xs="12" md="4" sm="4">
                      <span>Date: {{ transferRecord.DocDate }}</span>
                    </v-col>

                    <v-col cols="12" xs="12" md="4" sm="4">
                      <span>
                        From:
                        {{
                        transferRecord.fromstore &&
                        transferRecord.fromstore.Name
                        }}
                      </span>
                    </v-col>

                    <v-col cols="12" xs="12" md="4" sm="4">
                      <span>
                        To:
                        {{
                        transferRecord.tostore && transferRecord.tostore.Name
                        }}
                      </span>
                    </v-col>

                    <v-col cols="12" id="docForm">
                      <v-text-field v-model="search" label="search" dense outlined></v-text-field>
                      <v-data-table
                        light
                        :search="search"
                        :mobile-breakpoint="0"
                        :items-per-page="1000"
                        :headers="transferHeaders"
                        :items="transferRecord.rows"
                        item-key="id"
                        hide-default-footer
                      ></v-data-table>
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-divider></v-divider>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- end of dialog -->

          <!-- sale return dialog -->
          <v-dialog
            v-model="saleReturnDialog"
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
          >
            <v-card>
              <v-toolbar dark color="accent" dense>
                <v-toolbar-title>
                  <v-btn icon dark @click.native="saleReturnDialog = false">
                    <v-icon dark>mdi-keyboard-backspace</v-icon>
                  </v-btn>
                  {{ docName }}
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click.native="saleReturnDialog = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>

              <v-card-text>
                <v-container>
                  <v-row dense id="po" class="text--primary subtitle-2">
                    <v-col cols="12" xs="12" md="4" sm="4">
                      <span>
                        Business Partner:
                        {{
                        saleReturnRecord.ocrd && saleReturnRecord.ocrd.Name
                        }}
                      </span>
                    </v-col>

                    <v-col cols="12" xs="12" md="4" sm="4">
                      <span v-if="saleReturnRecord.DocTotal">
                        Total Amount:
                        {{ saleReturnRecord.DocTotal.toLocaleString() }}
                      </span>
                    </v-col>

                    <v-col
                      cols="12"
                      xs="12"
                      md="4"
                      sm="4"
                    >Return Date: {{ saleReturnRecord.DocDate }}</v-col>

                    <v-col cols="12" id="docForm">
                      <v-data-table
                        light
                        :mobile-breakpoint="0"
                        :items-per-page="1000"
                        :headers="saleReturnHeaders"
                        :items="saleReturnRecord.rows"
                        item-key="id"
                        hide-default-footer
                      >
                        <template v-slot:item.product="{ item }">
                          <span style="color: red">
                            {{
                            item.product.Name
                            }}
                          </span>
                        </template>

                        <template v-slot:item.Quantity="{ item }">
                          <span style="color: red">{{ item.Quantity }}</span>
                        </template>

                        <template v-slot:item.Price="{ item }">
                          <span v-if="item.Price" style="color: red">
                            {{
                            item.Price.toLocaleString()
                            }}
                          </span>
                        </template>

                        <template v-slot:item.LineTotal="{ item }">
                          <span v-if="item.LineTotal" style="color: red">
                            {{
                            item.LineTotal.toLocaleString()
                            }}
                          </span>
                        </template>
                      </v-data-table>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- end of dialog -->

          <snackbar ref="snackbar"></snackbar>
        </div>
      </v-card-text>
    </v-card>
    <!-- snackbar -->
    <snackbar ref="snackbar"></snackbar>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      inventoryUom: "",
      OpeningQty: 0,
      ClosingQty: 0,
      record: {},
      docName: "",
      queryStore: null,
      stores: [],
      transRecord: {},
      transferRecord: {},
      saleReturnRecord: {},
      menu1: false,
      menu2: false,
      search: null,
      loader: false,
      brands: [],
      product: {},
      stockReport: [],
      categories: [],
      auditData: [],
      salePurchaseDialog: false,
      saleReturnDialog: false,
      transferDialog: false,
      headers: [
        { text: "Product", value: "product.Name" },
        { text: "Available Qty", value: "AvailableQty" }
      ],
      auditHeaders: [
        { text: "Label", value: "Title" },
        { text: "In", value: "InQty" },
        { text: "Out", value: "OutQty" },
        { text: "Unit", value: "" },
        { text: "Stock Balance", value: "Balance" },
        { text: "Date", value: "DocDate" }
      ],
      transHeaders: [
        { text: "Product", value: "product.Name" },
        { text: "Qty", value: "Quantity" },
        { text: "Price", value: "Price" },
        { text: "Total", value: "LineTotal" }
      ],
      transferHeaders: [
        { text: "Product", value: "product.Name" },
        { text: "Ref No./ IMEI", value: "ref1" },
        { text: "Quantity", value: "Quantity" },
        { text: "From Shop", value: "fromstore.Name" },
        { text: "To Store", value: "tostore.Name" },
        { text: "Picked By", value: "pickedby.name" },
        { text: "Date", value: "DocDate" }
      ],
      saleReturnHeaders: [
        { text: "Product", value: "product" },
        { text: "Qty", value: "Quantity" },
        { text: "Price", value: "Price" },
        { text: "Total", value: "LineTotal" }
      ]
    };
  },
  computed: {
    storeName() {
      return localStorage.getItem("storeName");
    }
  },
  watch: {
    "$route.params.id": {
      handler: "getProduct",
      immediate: true
    }
  },
  methods: {
    getReport() {
      if (!this.queryStore) {
        this.$refs.snackbar.show("Please select a store", "red");
        return;
      }

      if (!this.record.StartDate) {
        this.$refs.snackbar.show("Please select a start date", "red");
        return;
      }

      if (!this.record.EndDate) {
        this.$refs.snackbar.show("Please select an end date", "red");
        return;
      }

      const data = this.record;
      data.ProductId = this.product.id;
      data.StoreId = this.queryStore;
      const url = "/product-audit-report";
      const self = this;
      this.loader = true;
      this.$store
        .dispatch("post", { url, data })
        .then(res => {
          if (res.ResultCode == 1200) {
            self.OpeningQty = res.ResponseData.OpeningQty;
            self.ClosingQty = res.ResponseData.ClosingQty;
            if(res.ResponseData.StockAuditData == null) {
              self.auditData = [];
            } else {
              self.auditData = res.ResponseData.StockAuditData;
            }

            self.loader = false;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
            self.loader = false;
          }
          self.loader = false;
        })
        .catch(err => {
          self.loader = false;
          this.$refs.snackbar.show(err, "red");
        });
    },
    getProduct(id) {
      const self = this;
      this.$store.commit("loader", true);
      this.$store
        .dispatch("get", `/products/${id}`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.product = res.ResponseData;
            self.$store.commit("loader", false);
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
        });
    },
    getPurchasesById(val) {
      const self = this;
      self.$store.commit("loader", true);
      this.$store
        .dispatch("get", `/documents/12/${val}`)
        .then(res => {
          if (res.ResultCode == 1200) {
            this.transRecord = res.ResponseData;
            self.salePurchaseDialog = true;
            self.docName = "Purchase Details";
            self.$store.commit("loader", false);
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
            self.$store.commit("loader", false);
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
          self.$store.commit("loader", false);
        });
    },
    getSalesById(val) {
      const self = this;
      // get record
      self.$store.commit("loader", true);
      this.$store
        .dispatch("get", `/documents/14/${val}`)
        .then(res => {
          if (res.ResultCode == 1200) {
            this.transRecord = res.ResponseData;
            self.salePurchaseDialog = true;
            self.docName = "Sale Details";
            self.$store.commit("loader", false);
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
            self.$store.commit("loader", false);
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
          self.$store.commit("loader", false);
        });
    },
    getTransferData(val) {
      const self = this;
      // get record
      self.$store.commit("loader", true);
      this.$store
        .dispatch("get", `/stock-transfer/${val}`)
        .then(res => {
          if (res.ResultCode == 1200) {
            this.transferRecord = res.ResponseData;
            self.transferDialog = true;
            self.$store.commit("loader", false);
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
            self.$store.commit("loader", false);
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
          self.$store.commit("loader", false);
        });
    },
    salesReturnData(val) {
      const self = this;
      // get record
      self.$store.commit("loader", true);
      this.$store
        .dispatch("get", `/customer-sales-return/${val}`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.saleReturnRecord = res.ResponseData;
            self.saleReturnDialog = true;
            self.docName = "Sale Return Details";
            self.$store.commit("loader", false);
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
            self.$store.commit("loader", false);
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
          self.$store.commit("loader", false);
        });
    },
    purchaseReturnData(val) {
      const self = this;
      // get record
      self.$store.commit("loader", true);
      this.$store
        .dispatch("get", `/supplier-purchases-return/${val}`)
        .then(res => {
          if (res.ResultCode == 1200) {
            self.saleReturnRecord = res.ResponseData;
            self.saleReturnDialog = true;
            self.docName = "Purchase Return Details";
            self.$store.commit("loader", false);
          } else {
            this.$refs.snackbar.show(res.ResultDesc, "red");
            self.$store.commit("loader", false);
          }
        })
        .catch(err => {
          this.$refs.snackbar.show(err, "red");
          self.$store.commit("loader", false);
        });
    },
    getStores() {
      const self = this;
      this.$store
        .dispatch("get", `/stores`)
        .then((res) => {
          if (res.ResultCode == 1200) {
            self.stores = res.ResponseData;
          } else {
            this.$refs.snackbar.show(res.msg, "red");
          }
        })
        .catch((err) => {
          this.$refs.snackbar.show(err, "red");
        });
    }
  },
  created() {
    this.getStores();
  }
};
</script>

<style lang="scss" scoped>
</style>